import React from "react";
import { Grid, Typography } from "@mui/material";
import ShieldRoundedIcon from "@mui/icons-material/ShieldRounded";
import EmojiEventsRoundedIcon from "@mui/icons-material/EmojiEventsRounded";
import AlarmRoundedIcon from "@mui/icons-material/AlarmRounded";
import { BenefitCard, BenefitAvatar } from "../styles/StyledComponents";

const benefits = [
  {
    icon: ShieldRoundedIcon,
    bgcolor: "rgba(28, 117, 255, 0.12)",
    color: "#1c75ff",
    title: "100% Gratuito",
    description: "Nessun costo nascosto, confronto sempre gratuito",
  },
  {
    icon: EmojiEventsRoundedIcon,
    bgcolor: "rgba(255, 152, 0, 0.12)",
    color: "#ff9800",
    title: "Migliori Compagnie",
    description: "Confrontiamo solo le compagnie più affidabili",
  },
  {
    icon: AlarmRoundedIcon,
    bgcolor: "rgba(76, 175, 80, 0.12)",
    color: "#4caf50",
    title: "Risultato Immediato",
    description: "Ricevi le migliori offerte in pochi secondi",
  },
];

export default function BenefitCards() {
  return (
    <Grid container spacing={3}>
      {benefits.map((benefit, index) => {
        const IconComponent = benefit.icon;
        return (
          <Grid item xs={12} md={4} key={index}>
            <BenefitCard>
              <BenefitAvatar bgcolor={benefit.bgcolor} color={benefit.color}>
                <IconComponent fontSize="large" />
              </BenefitAvatar>
              <Typography variant="h6" fontWeight={700} gutterBottom>
                {benefit.title}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {benefit.description}
              </Typography>
            </BenefitCard>
          </Grid>
        );
      })}
    </Grid>
  );
}
